import { useCallback, useEffect, useState } from "react";
import { canManageCommercialLicenseRequests } from "@/lib/commercialLicenseRequests";
import { listMyLicenseRequests } from "@/lib/commercialLicenseRequestsApi";

/** Gate de solicitudes comerciales (bloqueo 72 h / pendiente). */
export function useCommercialSubmissionGate(user, enabled = true) {
  const canManage = canManageCommercialLicenseRequests(user);
  const [gate, setGate] = useState(null);
  const [loading, setLoading] = useState(false);

  const refreshGate = useCallback(async () => {
    if (!canManage || !enabled) {
      setGate(null);
      return null;
    }
    setLoading(true);
    try {
      const data = await listMyLicenseRequests();
      setGate(data?.submission_gate || null);
      return data;
    } catch {
      setGate(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, [canManage, enabled]);

  useEffect(() => {
    refreshGate();
  }, [refreshGate]);

  return { gate, setGate, refreshGate, loading, canManage };
}
